const API_KEY = 'AIzaSyCTcFJoQqJX8GDvHM1vIjwuEdZpOu4jX5c'; // Your provided API key

export const searchWorshipStreams = async (maxResults) => {
  try {
    // Compose the YouTube API URL with search query for 24/7 live Christian worship, limited to US region
    const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=live&q=24%2F7+live+christian+worship&type=video&maxResults=${maxResults}&regionCode=US&key=${API_KEY}`;
    console.log('Fetching YouTube API with URL:', url);

    const response = await fetch(url);
    console.log('Response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.log('Error response:', errorText);
      throw new Error(`HTTP error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    console.log('YouTube API Response:', data);

    if (data.error) {
      console.error('YouTube API error:', data.error);
      throw new Error(data.error.message);
    }

    // Keywords to exclude to filter out non-Christian religions or unrelated content
    const blacklistedKeywords = [
      'islam', 'islamic', 'quran', 'allah',
      'hindu', 'hinduism', 'buddha', 'buddhism',
      'mantra', 'ramadan', 'mosque', 'temple',
      'meditation', 'sanskrit', 'sikh', 'krishna',
      'judaism', 'jewish', 'atheist', 'agnostic', 'pagan'
    ];

    // Helper function to check if a text contains any blacklisted keyword
    const isChristianContent = (text) => {
      const lower = text.toLowerCase();
      return !blacklistedKeywords.some(keyword => lower.includes(keyword));
    };

    // Filter items by checking title, channelTitle, and description for blacklisted keywords
    const filteredItems = (data.items || []).filter(item => {
      const snippet = item.snippet || {};
      return isChristianContent(snippet.title || '') &&
             isChristianContent(snippet.channelTitle || '') &&
             isChristianContent(snippet.description || '');
    });

    console.log('Filtered Christian-only results:', filteredItems);
    return filteredItems;

  } catch (error) {
    console.error('Error in searchWorshipStreams:', error);
    if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
      console.error('Network error or CORS issue.');
    }
    throw error;
  }
};





// const API_KEY = 'AIzaSyCTcFJoQqJX8GDvHM1vIjwuEdZpOu4jX5c'; // Your provided API key

// export const searchWorshipStreams = async (maxResults) => {
//   try {
//     const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&eventType=live&q=24%2F7+live+christian+worship&type=video&maxResults=${maxResults}&key=${API_KEY}`;
//     console.log('Fetching YouTube API with URL:', url);
//     const response = await fetch(url);
//     console.log('Response status:', response.status);
//     if (!response.ok) {
//       const errorText = await response.text();
//       console.log('Error response:', errorText);
//       throw new Error(`HTTP error: ${response.status} - ${errorText}`);
//     }
//     const data = await response.json();
//     console.log('YouTube API Response:', data);
//     if (data.error) {
//       console.error('YouTube API error:', data.error);
//       throw new Error(data.error.message);
//     }
//     console.log('Returning items:', data.items || []);
//     return data.items || [];
//   } catch (error) {
//     console.error('Error in searchWorshipStreams:', error);
//     if (error.name === 'TypeError' && error.message === 'Failed to fetch') {
//       console.error('Network error or CORS issue.');
//     }
//     throw error;
//   }
// };
